import React, { useState } from "react";
import { ProgressContext } from "./MolstackContexts";
import StackViewer from "./StackViewer";
import StackSelector from "./StackSelector";
import ProgressOverlay from "./ProgressOverlay";
import StackInfoOverlay from "./overlays/StackInfoOverlay";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Draggable from "react-draggable";
import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core";

const useSplitStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: "flex"
    //flexDirection: orientation => orientation === 'vertical' ? 'column' : 'row',
  }
}));

const useHandleStyles = makeStyles(theme => ({
  handle: {
    position: "absolute",
    top: "10%",
    left: 0,
    width: props => props.width - 2,
    height: props => props.height,
    marginLeft: props => -props.width / 2,
    backgroundColor: "rgb(255, 255, 255)",
    border: "2px solid white",
    borderRadius: props => props.height,
    paddingTop: "5px",
    paddingBottom: "5px"
  },
  container: {
    position: "absolute",
    left: props => `calc(50% - ${props.width / 2 + 8}px)`,
    top: 0,
    height: "100%",
    width: props => props.width + 16,
    zIndex: 6,
    cursor: "col-resize"
  },
  divider: {
    position: "absolute",
    left: "50%",
    top: 0,
    height: "100%",
    width: "0px",
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
    backgroundColor: "white"
  }
}));

const useBlendedStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    position: "relative"
  },
  stack: {
    height: "auto",
    width: "auto",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  clip: {
    clipPath: props => `inset(0 calc(50% - ${props.handlePosition}px) 0 0)`,
    WebkitClipPath: props =>
      `inset(0 calc(50% - ${props.handlePosition}px) 0 0)`,
    zIndex: 5
  },
  selectors: {
    width: "100%",
    display: "flex",
    position: "absolute",
    bottom: "15px",
    paddingLeft: "15px",
    paddingRight: "15px",
    boxSizing: "border-box",
    justifyContent: "space-between",
    zIndex: 10
  }
}));

function SplitContainer({ type, orientation, onWheel, viewers, stacks, view }) {
  const classes = useSplitStyles(); //orientation);

  if (type === "single") {
    viewers = [viewers[0]];
  }

  const elements = viewers.map(v => (
    <ProgressContext.Provider value={v.progress}>
      <StackViewer
        key={v.instance.id}
        viewer={v.instance}
        stacks={stacks}
        active_stack_id={v.currentStack}
        view={view}
      >
        <StackSelector
          side="right"
          stacks={stacks}
          current={v.currentStack}
          onChange={v.onStackChange}
        />
        <ProgressOverlay completed={v.completed} />
        {stacks.length && v.currentStack != null && <StackInfoOverlay
          stack={stacks.find(stack => {
            return stack.id === v.currentStack;
          })}
        />}
      </StackViewer>
    </ProgressContext.Provider>
  ));
  return (
    <div className={classes.root} onWheel={onWheel}>
      {" "}
      {elements}{" "}
    </div>
  );
}

function BlendHandle({ onDrag }) {
  const width = 50;
  const height = 24;

  const classes = useHandleStyles({ width, height });

  return (
    // <Draggable  axis='x'
    //   handle=".handle"
    //   positionOffset={{x: '50%', y:'50%'}}
    // >
    <Draggable bounds="parent" axis="x" onDrag={onDrag}>
      <div className={classes.container}>
        <div className={classes.divider}>
          <div className={classes.handle}>
            <ChevronLeftIcon />
            <ChevronRightIcon />
          </div>
        </div>
      </div>
    </Draggable>
  );
}

function BlendedContainer({
  type,
  orientation,
  onWheel,
  viewers,
  stacks,
  view
}) {
  const [handlePosition, setHandlePosition] = useState(0);
  const classes = useBlendedStyles({ handlePosition });

  const selectorStyle = {
    position: "unset",
    bottom: "unset",
    zIndex: "unset"
  };

  viewers = viewers.slice(0, 2); // Just two viewers
  const elements = viewers.map((v, idx) => (
    <ProgressContext.Provider value={v.progress}>
      <StackViewer
        key={v.instance.id}
        viewer={v.instance}
        stacks={stacks}
        active_stack_id={v.currentStack}
        view={view}
        classes={{ root: `${classes.stack} ${idx == 0 ? classes.clip : ""}` }}
      ></StackViewer>
    </ProgressContext.Provider>
  ));
  return (
    <div className={classes.root} onWheel={onWheel}>
      {elements}
      <div className={classes.selectors}>
        <StackSelector
          side="right"
          stacks={stacks}
          current={viewers[0].currentStack}
          onChange={viewers[0].onStackChange}
          style={selectorStyle}
        />
        <StackSelector
          side="left"
          stacks={stacks}
          current={viewers[1].currentStack}
          onChange={viewers[1].onStackChange}
          style={selectorStyle}
        />
      </div>
      <ProgressOverlay completed={viewers[0].completed} />
      <BlendHandle onDrag={(e, data) => setHandlePosition(data.x)} />
    </div>
  );
}

export default function StacksContainer({ type, ...props }) {
  let Container = SplitContainer;
  if (type === "blend") {
    Container = BlendedContainer;
  }

  return <Container type={type} {...props} />;
}
